import { Box, Typography, Alert } from '@mui/material';
import { ServiceMetricsDataCellProps } from '../types';
import { DATA_TYPES, dataTypes } from '@constants';
import * as IntegrationTypes from 'IntegrationModule/types';
import { getSyncRatioAlertDisplay } from 'utils/display';

const ServiceMetricsDetailsRowCell = ({ dataTypeMetrics }: ServiceMetricsDataCellProps) => {
  return (
    <Box
      sx={{
        p: 2,
        bgcolor: (theme: any) => (theme.palette.mode === 'dark' ? '#1e293b' : '#f8fafc'),
      }}
    >
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          color: 'text.primary',
        }}
      >
        Sync Details by Data Type
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 2,
        }}
      >
        {DATA_TYPES.map((dataType) => {
          const countsByDataType: IntegrationTypes.CountPerDataTypeValues =
            dataTypeMetrics[dataType] || {};

          const totalCreate = countsByDataType.totalCreate ?? 0;
          const totalUpdate = countsByDataType.totalUpdate ?? 0;
          const updateOnMosaic = countsByDataType.updateOnMosaic ?? 0;
          const updateOnTarget = countsByDataType.updateOnTarget ?? 0;
          const createOnMosaic = countsByDataType.createOnMosaic ?? 0;
          const createOnTarget = countsByDataType.createOnTarget ?? 0;

          const totalCreateAndUpdate = totalCreate + totalUpdate;

          const ratioPercentage = !totalCreateAndUpdate
            ? 0
            : 100 - Math.floor((totalCreate / totalCreateAndUpdate) * 100);

          const severity = getSyncRatioAlertDisplay(countsByDataType, ratioPercentage);

          const dataTypeConfig = dataTypes.find((dt) => dt.value === dataType);
          const label = dataTypeConfig?.label || dataType;

          return (
            <Box
              key={dataType}
              sx={{
                minWidth: 250,
                maxWidth: 350,
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                bgcolor: (theme: any) => (theme.palette.mode === 'dark' ? '#0f172a' : '#ffffff'),
                transition: 'all 0.2s',
                '&:hover': {
                  boxShadow: 2,
                  borderColor: 'primary.main',
                },
              }}
            >
              <Typography
                variant="subtitle2"
                gutterBottom
                sx={{
                  fontWeight: 'bold',
                  color: 'text.primary',
                }}
              >
                {label}
              </Typography>
              <Alert severity={severity as any} sx={{ mb: 1.5 }}>
                {totalCreate} / {totalCreateAndUpdate}
              </Alert>
              <Box
                sx={{
                  fontSize: '0.85rem',
                  color: 'text.secondary',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 0.5,
                  }}
                >
                  <span>Update on Mosaic:</span>
                  <strong>{updateOnMosaic}</strong>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 0.5,
                  }}
                >
                  <span>Update on Target:</span>
                  <strong>{updateOnTarget}</strong>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 0.5,
                  }}
                >
                  <span>Total Update:</span>
                  <strong>{totalUpdate}</strong>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 0.5,
                  }}
                >
                  <span>Create on Target:</span>
                  <strong>{createOnTarget}</strong>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mb: 0.5,
                  }}
                >
                  <span>Create on Mosaic:</span>
                  <strong>{createOnMosaic}</strong>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    fontWeight: 'bold',
                  }}
                >
                  <span>Total Create:</span>
                  <strong>{totalCreate}</strong>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default ServiceMetricsDetailsRowCell;
